<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 animate-fade-in-up">
    <div class="w-full flex justify-between mb-4">
        <app-btn-back routeTo="/profile/details" icon="fa fa-close" btnText="Cancel"></app-btn-back>
    </div>

    <div class="w-full mb-4">
        <h6 class="text-primary-500 text-lg font-bold uppercase">
            Edit Profile
        </h6>
    </div>

    <div class="w-full">
        <form [formGroup]="pageForm" (submit)="update()">
            <div class="flex flex-col-reverse lg:flex-row w-full">
                <div class="flex flex-wrap w-full relative">

                    <div class="w-full mb-2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            Name *
                        </label>
                        <input type="text"
                            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded capitalize text-sm shadow focus:ring w-full ease-linear transition-all duration-150"
                            placeholder="Name" formControlName="name" name="name" required>
                        <div
                            class="{{pageForm.get('name')?.invalid && (pageForm.get('name')?.dirty || pageForm.get('name')?.touched) ? 'visible' : 'invisible' }} pt-1 h-6 text-red-500 text-xs">
                            <p *ngIf="pageForm.get('name')?.errors?.['required']">
                                Value is required
                            </p>
                        </div>
                    </div>

                    <div class="w-full mb-4">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            Profession
                        </label>
                        <input type="text"
                            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:ring w-full ease-linear transition-all duration-150"
                            placeholder="Profession" formControlName="profession" name="profession">
                    </div>

                    <div class="w-full mb-2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            Contact
                        </label>
                        <app-contact name="contact" formControlName="contact"></app-contact>
                    </div>

                    <div class="flex flex-row gap-4 w-full mb-4">

                        <div class="w-1/2">
                            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                Date of Birth
                            </label>
                            <input type="date" name="dob" formControlName="dob" placeholder="dd/mm/yyyy"
                                class="border-0 px-3 py-3 placeholder:text-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:ring w-full ease-linear transition-all duration-150"
                                min="1900-01-01" [max]="today">
                        </div>
                        <div class="w-1/2">
                            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                gender
                            </label>
                            <app-gender name="gender" formControlName="gender"></app-gender>
                        </div>

                    </div>

                    <div class="w-full mb-6">
                        <app-checkbox formControlName="isDobViewable"
                            label="Show Date of Birth in Public Profile"></app-checkbox>
                    </div>

                    <div class="w-full mb-6">
                        <app-checkbox formControlName="useUserCreditsFirst"
                            label="Use personal AI credits first before using group credits"></app-checkbox>
                    </div>

                    <!-- Address -->
                    <div class="flex flex-row gap-4 w-full">
                        <div class="w-1/2">
                            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                Flat / Villa No
                            </label>
                            <input type="string" name="buildingNo" formControlName="buildingNo"
                                placeholder="House/Flat Number"
                                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:ring w-full ease-linear transition-all duration-150">
                            <div class="pt-1 h-6"></div>
                        </div>
                        <div class="w-1/2">
                            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                Building Name
                            </label>
                            <input type="string" name="buildingName" formControlName="buildingName"
                                placeholder="Building Name"
                                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:ring w-full ease-linear transition-all duration-150">
                            <div class=" pt-1 h-6"></div>
                        </div>
                    </div>
                    <div class="flex flex-row gap-4 w-full">
                        <div class="w-1/2">
                            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                Address Line 1
                            </label>
                            <input type="string" name="addressLine1" formControlName="addressLine1"
                                placeholder="Address Line 1"
                                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:ring w-full ease-linear transition-all duration-150">
                            <div class=" pt-1 h-6"></div>
                        </div>
                        <div class="w-1/2">
                            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                Address Line 2
                            </label>
                            <input type="string" name="addressLine2" formControlName="addressLine2"
                                placeholder="Address Line 2"
                                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:ring w-full ease-linear transition-all duration-150">
                        </div>
                    </div>
                    <div class="flex flex-row gap-4 w-full">
                        <div class="w-1/2">
                            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                City *
                            </label>
                            <input type="text" name="city" formControlName="city" placeholder="City"
                                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:ring w-full ease-linear transition-all duration-150"
                                required>
                            <div
                                class="{{pageForm.get('city')?.invalid && (pageForm.get('city')?.dirty || pageForm.get('city')?.touched) ? 'visible' : 'invisible' }} pt-1 h-6 text-red-500 text-xs">
                                <p *ngIf="pageForm.get('city')?.errors?.['required']">
                                    Value is required
                                </p>
                            </div>
                        </div>
                        <div class="w-1/2">
                            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                Country *
                            </label>
                            <app-country name="country" formControlName="country"></app-country>
                        </div>
                    </div>

                    <div class="w-full">
                        <app-btn-submit [isDisabled]="pageForm.invalid" [isLoading]="working" [actionText]="'Update'"
                            [icon]="'fa fa-save'"></app-btn-submit>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>